// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__IdjwH","header":"MessagesList_header__2blFK","chat":"MessagesList_chat__2sb2U"};